import { useEffect } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import SAISVG, { toAbsoluteUrl } from '../../../helpers/CommonFunction'
import { useLayout } from '../../core/LayoutProvider'
import PageTitle from '../toolbar/page-title/PageTitle'
import Navbar from './Navbar'

const HeaderWrapper = () => {
    useEffect(() => {
        document.body.setAttribute('data-sai-app-header-fixed', 'true')
    }, [])

    const { config, classes } = useLayout()
    if (!config.app?.header?.display) {
        return null
    }

    return (
        <>
            <div className="app-header bg-dark">
                <div className="app-container container-xxl d-flex align-items-stretch justify-content-between">
                    <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15">
                        <a href="#">
                            <img alt="Logo" src="/truvoice_logo-new.png" className="h-50px app-sidebar-logo-default" />
                        </a>
                    </div>
                    <div className="d-flex align-items-stretch justify-content-between">
                       <Navbar/>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HeaderWrapper